import React, { useEffect, useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import "./SubscriptionIncludedApps.css";
import { platformApiUrl } from "../config/api";

const INCLUDED_APPS_URL = platformApiUrl("apps/subscription_included.php");
const FINANSI_WEB_URL = "https://finansi.simolapps.ru/";

const shortName = (name) => String(name || "Приложение").split(/\s[-—–]\s/, 1)[0];
const isFinansi = (app) =>
  /finans|финанс/i.test(`${app?.slug || ""} ${app?.name || ""}`);

export default function SubscriptionIncludedApps({ className = "" }) {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    fetch(INCLUDED_APPS_URL, {
      cache: "no-store",
      signal: controller.signal,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.success && Array.isArray(data.apps)) {
          setApps(data.apps.filter((app) => app?.download_url));
        }
      })
      .catch((error) => {
        if (error?.name !== "AbortError") setApps([]);
      });

    return () => controller.abort();
  }, []);

  if (!apps.length) return null;

  return (
    <section className={`subscription-apps-strip ${className}`.trim()} aria-label="В подписку входят приложения">
      <div className="subscription-apps-strip__title">В подписку входит</div>
      <div className="subscription-apps-strip__items">
        {apps.map((app) => {
          const finance = isFinansi(app);
          const content = <>
            <img
              className="subscription-app-link__icon"
              src={app.icon_url || "/downloads/apps/finansi-android/icon.png"}
              alt=""
            />
            <span className="subscription-app-link__text">
              <strong>{shortName(app.name)}</strong>
              <small>{finance ? "Веб-кабинет и мобильное приложение" : "Скачать приложение"}</small>
            </span>
          </>;

          return finance ? (
            <article key={app.id || app.slug} className="subscription-app-link subscription-app-link--finance">
              <div className="subscription-app-link__summary">{content}</div>
              <div className="subscription-app-link__actions">
                <a href={FINANSI_WEB_URL} target="_blank" rel="noreferrer">Открыть веб-версию</a>
                <a href={app.download_url} target="_blank" rel="noreferrer">Скачать приложение</a>
              </div>
            </article>
          ) : (
            <a
              key={app.id || app.slug}
              className="subscription-app-link"
              href={app.download_url}
              target="_blank"
              rel="noreferrer"
              aria-label={`Открыть приложение «${app.name}»`}
            >
              {content}
              <ArrowRightOutlined className="subscription-app-link__arrow" />
            </a>
          );
        })}
      </div>
    </section>
  );
}
